import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import {action} from 'mobx';

import store from '../store/store.js'

import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';

const OptionsList = observer((props) => {
  const turType = props.turType;
  const options = store.options;
  const optionStyle = {width: 400};
  const textFieldStyle = {width: "100%"};
  
  function handleChange(name, value) {
    if (name === 'food') {
      store.changeOption('food', !store.options.food )
    } else if (name === 'bilet') {
      store.changeOption('bilet', !store.options.bilet )  
    } else {
      store.changeOption(name, value);
    }
  };

  return (
      <Fragment>
        <div style={optionStyle}>
          <TextField
              style={textFieldStyle}
              value={options.manag}
              name="manag"
              onChange={(event) => handleChange("manag", event.target.value)}
              type='text'
              floatingLabelText='Мэнеджер' 
              errorText={ !options.manag && store.showErrors ? 'заполните поле' : null }
            />
        </div>
        <div style={optionStyle}>
          <TextField
              style={textFieldStyle}
              value={options.telef}
              name="telef"
              onChange={(event) => handleChange("telef", event.target.value)}
              type='text'
              floatingLabelText='Телефон' 
              errorText={ !options.telef && store.showErrors ? 'заполните поле' : null }
            />
        </div>
        <div style={optionStyle}>
          <TextField
              style={textFieldStyle}
              value={options.tur.name}
              name="tur"
              onChange={null}
              type='text'
              floatingLabelText='Тур' 
            />
        </div>
        <div style={optionStyle}>
          <TextField
              style={textFieldStyle}
              value={options.hotel.name}
              name="hotel"
              onChange={null}
              type='text'
              floatingLabelText='Отель' 
            />
        </div>
        <div style={turType === 'r' ? {display: 'none'} : optionStyle}>
          <SelectField
            floatingLabelText="Город посадки"
            value={options.city}
            onChange={(e,i,v) => handleChange('city', v)}
            errorText={ options.city === -1 && store.showErrors ? 'выберите город' : null }
          >
            {store.cities.map((item, index)=>{
              return <MenuItem key={index} value={index} primaryText={item} />
            } )}
          </SelectField>
        </div>
        <div style={optionStyle}>
          <TextField
              style={textFieldStyle}
              value={options.summa}
              name="summa"
              onChange={(event) => handleChange("summa", event.target.value)}
              type='number'
              min='0'
              step='100'
              floatingLabelText='Сумма заявки' 
            />
        </div>
        <div style={{marginTop: 20, width: 256}}>
          <Checkbox 
              name = "food"
              label = "Питание"
              checked = {options.food}
              onCheck = {() => handleChange('food') }
            />
        </div>
        <div style={turType === 'a'? {display: 'none'} : {marginTop: 20, width: 256}} >
          <Checkbox 
              name = "bilet"
              label = "ЖД-билеты"
              checked = {options.bilet}
              onCheck = {() => handleChange('bilet') }
            />
        </div>
        <div style={turType === 'a' ? {display: 'none'} : optionStyle}>
          <SelectField
            floatingLabelText="Трансфер"
            value={options.transfer}
            onChange={(e,i,v) => handleChange('transfer', v)}
          >
            {store.transfers.map((item, index)=>{
              return <MenuItem key={index} value={index} primaryText={item} />
            } )}
          </SelectField>
        </div>
      </Fragment>
  );

});

export default OptionsList;




// WEBPACK FOOTER //
// ./src/coms/OptionsList.jsx